export default "__VITE_ASSET__p_7trCcs__"